// The real 2026-2027 sixth grade year calendar — reconciled against Katy's
// authoritative planning source, the "Cedar Vale Academy" iCloud folder
// (currently Cedar-Vale-6th-Grade-Planner-2026-2027.docx/pdf under "00
// Start Here"). Confirmed 2026-09-03: Sep 3/Sep 7 is correct — an earlier
// one-time shift to Aug 31 (to get the tracker usable immediately) was
// reverted, since her drive is the standing curriculum source of truth.
//
// The plan's Sep 3-4 (Thu-Fri) "soft start" is explicitly "routine only —
// set up the day, don't teach it," so it has no assignments to generate.
// It isn't represented in WEEKS (which the rest of this module assumes are
// Mondays — Sep 3 is a Thursday) or in the 180-day/832-hour totals below;
// those two real-world days are assumed handled outside the app. WEEKS
// starts at the first full Monday, Sep 7 — which is also Labor Day, so the
// first day with any generated assignments is Sep 8.
//
// Full-week breaks (Thanksgiving-adjacent week, winter break) are simply
// absent from WEEKS, same convention as before. HOLIDAYS marks single days
// off inside an otherwise-active week (Labor Day, and the tail end of the
// two two-day weeks before Thanksgiving and winter break).
//
// OPEN QUESTION, not yet resolved: spring break is explicitly "not yet set"
// in her plan — this calendar assumes none (matching her own 180-day/June 4
// baseline, which is calculated without one). Revisit WEEKS below once
// that's decided.
export const WEEKS = [
  '2026-09-07', '2026-09-14', '2026-09-21', '2026-09-28',                     // W1-4 — Q1
  '2026-10-05', '2026-10-12', '2026-10-19', '2026-10-26',                     // W5-8 — Q1 ends Oct 30
  '2026-11-02',                                                                // W9  — Q2 begins
  // full week off: Nov 9-13
  '2026-11-16', '2026-11-23',                                                  // W10-11 (W11 is 2 days — Thanksgiving)
  '2026-11-30', '2026-12-07', '2026-12-14', '2026-12-21',                      // W12-15 (W15 is 2 days — winter break)
  // full week off: Dec 28-Jan 1
  '2027-01-04', '2027-01-11', '2027-01-18', '2027-01-25',                      // W16-19 — Q3 begins
  '2027-02-01', '2027-02-08', '2027-02-15', '2027-02-22',                      // W20-23
  '2027-03-01', '2027-03-08',                                                  // W24-25 — Q3 ends Mar 12
  '2027-03-15', '2027-03-22', '2027-03-29',                                    // W26-28 — Q4 begins, Dimensions 6A opens W26
  '2027-04-05', '2027-04-12', '2027-04-19', '2027-04-26',                      // W29-32 — spring unit begins W29
  '2027-05-03', '2027-05-10', '2027-05-17', '2027-05-24', '2027-05-31',        // W33-37 — Q4 ends Jun 4
];

export const HOLIDAYS = {
  '2026-09-07': 'Labor Day',
  '2026-11-25': 'Thanksgiving break',
  '2026-11-26': 'Thanksgiving break',
  '2026-11-27': 'Thanksgiving break',
  '2026-12-23': 'Winter break',
  '2026-12-24': 'Winter break',
  '2026-12-25': 'Winter break',
};

// Clock-bound recurring commitments — days: ISO weekday numbers, 1=Mon..5=Fri.
// mins reflects the actual blocked-out time (swim includes ~15 min travel
// each way per her note: "the block is really 12:45-2:15"), not just the
// nominal lesson/activity length, since this is what a calendar hold should
// reserve.
export const ANCHORS = {
  tutor: { days: [1, 3], start: '10:30', mins: 30, label: 'Mr. McKenzie · reading & writing', color: 'tutor' },
  swim:  { days: [1, 3, 5], start: '12:45', mins: 90, label: 'Swim team (incl. travel)', color: 'swim' },
  coop:  { days: [4], start: '9:30', mins: 90, label: 'Co-op — two electives', color: 'coop' },
};

export function buildSchoolCalendar() {
  return {
    startDate: WEEKS[0],
    endDate: '2027-06-04',
    weeks: WEEKS,
    holidays: HOLIDAYS,
    dayStart: '08:30',
    anchors: ANCHORS,
    totalInstructionalDays: 178, // 180 per her plan, minus the 2 soft-start days not modeled here
  };
}
